const listeners = []

function on(callback) {
    listeners.push(callback)
}

function off(callback) {
    const index = listeners.indexOf(callback)

    if (index !== -1) {
        listeners.splice(index, 1)
    }
}

function fire() {
    listeners.forEach(listener => listener())
}

export default { on, off, fire }